import {
  CookieTokenType,
  EnvironmentType,
  ErrorHandlingModeType,
  IdSchemaType,
  LangType,
  OddClientConfig,
} from "../Types/ConfiguratorTypes";
import { FansUnitedAuthInterface } from "./FansUnitedAuthInterface";

export default class SDKConfigurationModel {
  apiKey: string;
  clientId: string;
  environment?: EnvironmentType;
  idSchema?: IdSchemaType;
  lang?: LangType;
  errorHandlingMode?: ErrorHandlingModeType;
  oddClient?: OddClientConfig;
  cookieToken?: CookieTokenType;
  authProvider?: FansUnitedAuthInterface;
}
